"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}
exports.hostReportError = hostReportError;
//# sourceMappingURL=hostReportError.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/internal/util/hostReportError.js
// module id = 437
// module chunks = 0